import React from "react";
import cn from "classnames";

import { getMessengerUrls } from "helpers/messengers";

import styles from "./styles.module.scss";

export const MESSAGE_ICON_SIZE = {
    compact: "compact",
    small: "small",
    normal: "normal",
};

const MessengerLink = ({ item, size = MESSAGE_ICON_SIZE.small, disabled = false, title = "" }) => {
    const className = cn(styles.logo, styles[`logo--${item.type}`], styles[`logo--${size}`], {
        [styles["logo--disabled"]]: disabled,
    });

    // Мессенджер не заполнен — иконка серая и некликабельная, вести по ней некуда
    if (disabled) {
        return (
            <span className={className} title={title || item.type}>
                <span>{item.type}</span>
            </span>
        );
    }

    return (
        <a
            href={getMessengerUrls(item.login)[item.type]}
            target="_blank"
            rel="noopener noreferrer"
            className={className}
            key={item.type}
            title={title || item.type}
        >
            <span>{item.type}</span>
        </a>
    );
};

export default MessengerLink;
